/*
Sohel 11/16/2022 2700912712 Implemented Basic Info Screen
Sohel 11/16/2022 2700912712 Save API Payload Changes.
Lalitha 30/11/2022 2700912712 Added validation on code
Sohel 12/01/2022 2700912712 Added Override Type in payload.
Sohel 12/04/2022 2700912712 Fixed Validation Issue.
Sai maheshwar 12/04/2022 2700912712 added unsaved changes alert
Sohel 12/04/2022 2698948956 button style changes.
Saikrishna 12/08/2022 2698948956 Removed name fields.
Saikrishna 12/09/2022 2698948956 save and stay in page functionality added.
Suresh Peddavoora 12/13/2022 2698948956 Fixed Button Spacing Alignments
Sohel 12/13/2022 2698948956 conditionally hide Save Button
lalitha 15/12/2022 2698948956 added access role in filter rule group
Ashraf 15/16/2022 2698948956 fixed role access
akhila 12/18/2022 2698948956 fixed code upperCase issue
akhila 20/12/2022 2698948956 fixed toast issue in basicInfo
akhila 20/12/2022 2698948956 fixed toast issue
Akhila 02/07/2023 2698948956 bug fixed cursor issue code field and implemented formik form
Sohel 02/10/2023 2698948956 fixed validation issue
Raghu 02/21/2023 2698948956 changed buttons color
Raghu 02/28/2023 2698948956 fixed alignment issue
sohel 03/06/2023 2698948956 Added validation message for existing value
Suresh Peddavoora 03/23/2023 2698948956 Fixed textfield label shrink issue
Prakash 03/28/2023 2698948956 fixed inputfiled alignments issue.
Prakash 24/05/2023 2698948956 fixed issue in tab view
Akhila 06/21/2023 2698948956 conditionally disable save and finish button on submission
Gireesh 12/11/2023 2698948956 added Filter Name and Filter Description  validations
Gireesh-pds 12/12/2023  2698948956 changed filter code name

*/
import {Button, TextField, FormHelperText, MenuItem} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import * as Yup from 'yup';
import {fetchFilterAllCodeAndDisplayName} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {
  postFilterRuleGroup,
  resetMessage,
  fetchFilterRuleGroup,
} from '../../../../redux/reducers/BRE/FilterRuleGroup';
// import {codeRegex} from '../../../../util/RegexPatterns';
// import {codeValidationMessage} from '../../../../util/Content';
import {currsorCodeIssue} from '../../../../components/UpperCaseCode';
import {Formik} from 'formik';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';
// import {nameWithSpecialCharacter} from '../../../../util/Content';
// import {nameRegexAllow} from '../../../../util/RegexPatterns';
const BasicInfo = ({handleBack, handleNext, activeStep, handleDirty, rowSelected}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  const {allFilterCodeAndDisplayName} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {
    loading,
    successMsg,
    errorMsg,
    filterRuleGroupData,
    addFilterRuleGroupStatus,
    filterRuleGroupId,
  } = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  const {roleData} = useSelector(({role}) => role);
  const filterRuleRoleAccess = roleData?.window?.['Filter Rules']?.['FR'];
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [codePopover, setCodePopover] = useState(false);
  const [filterCodesData, setFilterCodesData] = useState();
  const saveRef = useRef();
  const codeRef = useRef();
  const getFilterCodesData = () => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0) {
      return allFilterCodeAndDisplayName?.filter((i) =>
        String(i?.ruleGroupCode?.toUpperCase())?.startsWith(filterCodesData.toUpperCase()),
      );
    } else {
      return [];
    }
  };
  const initialValues = {
    code: filterRuleGroupData?.code ? filterRuleGroupData?.code : '',
    displayName: filterRuleGroupData?.displayName ? filterRuleGroupData.displayName : '',
    description: filterRuleGroupData?.description || '',
  };

  useEffect(() => {
    dispatch(fetchFilterAllCodeAndDisplayName());
  }, []);

  // useEffect(() => {
  //   reset(initialValues);
  // }, [filterRuleGroupData]);
  const checkCodeExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkCodeAlreadyExist = (value) => {
    if (allFilterCodeAndDisplayName && allFilterCodeAndDisplayName?.length > 0 && value) {
      const ar = [];
      allFilterCodeAndDisplayName.filter((i) => {
        if (
          i?.ruleGroupCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const validationSchema = Yup.object().shape({
    code: filterRuleGroupData?.code ?
      null :
      Yup.string()
        .required('Filter Name is required')
        .test('code', 'Filter Name already exist', (value) => !checkCodeExist(value))
        .test(
          'code',
          'Filter Name has already been used in the past',
          (value) => !checkCodeAlreadyExist(value)
        ),
    // Yup.string()
    //   .required('Filter Code is required')
    //   .matches(codeRegex, codeValidationMessage)
    //   .test('code', 'Filter Code already exist', (value) => !checkCodeExist(value))
    //   .test(
    //     'code',
    //     'Filter Code has already been used in the past',
    //     (value) => !checkCodeAlreadyExist(value),
    //   ),
    // displayName: filterRuleGroupData?.displayName
    //   ? null
    //   : Yup.string()
    //       .test("displayName", "Filter Name is required", (value) => {
    //         return value?.replaceAll(" ", "");
    //       })
    //       .required("Filter Name is required")
    //       .test(
    //         "displayName",
    //         "Filter Name already exist",
    //         (value) => !checkDisplayNameExist(value)
    //       ),
    description: Yup.string()
      // .test('description', 'Filter Description is required', (value) => {
      //   return value?.replaceAll(' ', '');
      // })
      .required('Filter Description is required')
  });

  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const payload = {
      sqlRules: filterRuleGroupData?.filterSQLRuleResponse ?
        filterRuleGroupData?.filterSQLRuleResponse :
        [],
      id: filterRuleGroupData?.id ? filterRuleGroupData?.id : 0,
      sqlDeletedId: [],
      override: '',
      code: filterRuleGroupData?.code ?
        filterRuleGroupData?.code :
        values?.code ?
          values?.code :
          '',
      description: values?.description ? values?.description : '',
      displayName: filterRuleGroupData?.displayName ?
        filterRuleGroupData?.displayName :
        values?.displayName ?
          values?.displayName :
          '',
      sqlExpression: filterRuleGroupData?.sqlExpression ? filterRuleGroupData?.sqlExpression : '',
      category: '',
      fieldListCode: filterRuleGroupData?.fieldListCode ? filterRuleGroupData?.fieldListCode : '',
      isDraft: filterRuleGroupData?.isDraft ? filterRuleGroupData?.isDraft : 'Y',
      oldFilterRuleGroupCode: '',
      overrideType: 'FILTER',
      defaultOperator: filterRuleGroupData?.defaultOperator,
    };
    dispatch(postFilterRuleGroup(payload));
  };
  useEffect(() => {
    if (addFilterRuleGroupStatus === 200 && !errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        !saveRef.current && handleNext();
        saveRef.current && dispatch(fetchFilterRuleGroup(filterRuleGroupId));
      }, 1000);
    }
  }, [addFilterRuleGroupStatus, errorMsg]);

  // useEffect(() => {
  //   if (filterRuleGroupId) {
  //     dispatch(fetchFilterRuleGroup(filterRuleGroupId));
  //   }
  // }, [filterRuleGroupId]);
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1000);
    }
  }, [errorMsg, successMsg]);
  window.onclick = function() {
    setCodePopover(false);
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                <div>
                  <div className="form-row new-standard-textfields mt-2">
                    <div className="col-sm-6 col-md-4 col-lg-4 form-group account-guarantor">
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder="Enter Filter Name"
                        margin="dense"
                        name="code"
                        value={values.code}
                        variant="outlined"
                        label="Filter Name"
                        disabled={Boolean(filterRuleGroupData?.code)}
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        inputProps={{maxLength: 25}}
                        onChange={(e) => {
                          const value = currsorCodeIssue(codeRef);
                          setFieldValue('code', value);
                          if (e.target.value) {
                            setCodePopover(true);
                            setFilterCodesData(e.target.value);
                          } else if (e.target.value === '') {
                            setCodePopover(false);
                          }
                        }}
                        required
                        inputRef={codeRef}
                        onBlur={handleBlur}
                        touched={touched.code}
                        fullWidth
                        error={Boolean(errors.code?.message)}
                      />
                      <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                      <div className="windowcode-popover Add-trigger-group-popover">
                        {codePopover &&
                          getFilterCodesData()?.map((data) => (
                            <MenuItem key={data?.ruleGroupCode}>{data?.ruleGroupCode?.replace(/ /g, '\u00a0')}</MenuItem>
                          ))}
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4 form-group account-guarantor">
                      <TextField
                        className={` ${classes.labelName}`}
                        placeholder="Enter Filter Description"
                        margin="dense"
                        name="description"
                        variant="outlined"
                        label="Filter Description"
                        value={values.description}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        // InputLabelProps={{
                        //   shrink: true,
                        // }}
                        inputProps={{maxLength: 100}}
                        fullWidth
                        touched={touched.description}
                        error={Boolean(errors.description?.message)}
                      />
                      <FormHelperText>
                        {touched.description && errors?.description && errors.description}
                      </FormHelperText>
                    </div>
                  </div>
                  <div className="new-standard-textfields d-flex justify-content-center align-items-center disabled-button">
                    <Button
                      variant="outlined"
                      className={`reset-btn mr-1 ${classes.buttonRoot}`}
                      disabled={activeStep === 0}
                      onClick={handleBack}
                    >
                      Back
                    </Button>
                    {/* {filterRuleGroupData?.isDraft === "N" && ( */}
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn mx-1 ${classes.buttonRoot}`}
                      disabled={
                        (!filterRuleRoleAccess?.edit && filterRuleGroupData?.code && rowSelected) ||
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = true;
                      }}
                    >
                      Save
                    </Button>
                    {/* )} */}
                    <Button
                      variant="outlined"
                      type="submit"
                      className={`search-btn ml-1 ${classes.buttonRoot}`}
                      disabled={
                        (!filterRuleRoleAccess?.edit && filterRuleGroupData?.code && rowSelected) ||
                        enabledSubmission
                      }
                      onClick={() => {
                        saveRef.current = false;
                      }}
                    >
                      Save & Next
                    </Button>
                  </div>
                </div>
              </form>
            </>
          );
        }}
      </Formik>
      {loading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default BasicInfo;
